import { createStructuredSelector } from "reselect";
import {
    ARTICLE_LIST_ORP,
    ARTICLE_LIST_ORP_SUCCESS,
    ARTICLE_LIST_ORP_ERROR,
    ARTICLE_LIST_ORP_MODAL_SET,
    ARTICLE_LIST_ORP_SEARCH_SET,
    ARTICLE_LIST_ORP_SEARCH_CHANGE,
    ARTICLE_LIST_ORP_VIEW_MODAL_SET,
    ARTICLE_LIST_ORP_DETAIL,
    ARTICLE_LIST_ORP_DETAIL_SUCCESS,
    ARTICLE_LIST_ORP_DETAIL_ERROR
} from "../actions";

export const NAME = 'articleList';

export const ArticleListOrp = ( filters) => ({
    type: ARTICLE_LIST_ORP,
    payload: {  filters: filters }
});

export const ArticleListOrpSuccess = (data) => ({
    type: ARTICLE_LIST_ORP_SUCCESS,
    payload: data
});

export const ArticleListOrpError = (error) => ({
    type: ARTICLE_LIST_ORP_ERROR,
    payload: error
});

export const ArticleListOrpModalSet = (data) => ({
    type: ARTICLE_LIST_ORP_MODAL_SET,
    payload: data
});

export const ArticleListOrpSearchSet = (data) => ({
    type: ARTICLE_LIST_ORP_SEARCH_SET,
    payload: data
});

export const ArticleListOrpSearchChangeSet = (data) => ({
    type: ARTICLE_LIST_ORP_SEARCH_CHANGE,
    payload: data
});

export const ArticleListOrpViewModalSet = (data) => ({
    type: ARTICLE_LIST_ORP_VIEW_MODAL_SET,
    payload: data
});

export const ArticleListOrpDetail = (filters) => ({
    type: ARTICLE_LIST_ORP_DETAIL,
    payload: { filters: filters }
});

export const ArticleListOrpDetailSuccess = (data) => ({
    type: ARTICLE_LIST_ORP_DETAIL_SUCCESS,
    payload: data
});

export const ArticleListOrpDetailError = (error) => ({
    type: ARTICLE_LIST_ORP_DETAIL_ERROR,
    payload: error
});

const articleList = (state) => state[NAME];

export const ArticleListOrpSelector = createStructuredSelector({
    articleList
})
